var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "#3D3D3D",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.557 22.277a1.333 1.333 0 0 0 1.886 0l6.666-6.667a1.334 1.334 0 0 0-1.885-1.885l-4.39 4.39V6.667a1.333 1.333 0 1 0-2.667 0v11.448l-4.391-4.39a1.334 1.334 0 0 0-1.885 1.885zM23.167 24H9.833a1.333 1.333 0 1 0 0 2.666h13.334a1.334 1.334 0 0 0 0-2.666"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.min.5bd23a6705ab12b4e368796aa433ee67.svg";